import { Outlet } from "react-router-dom";
import { CreateListingModal } from "../components/Requests/CreateListingModal";
import { Row, Col, Button, Grid, Modal } from "antd";
import { useState } from "react";
import "./RequestsPage.css";
import ImageBackground from "../components/marketplace/ImageBackground";
import { keycloak } from "../utils/keycloak";
const { useBreakpoint } = Grid;

const RequestsPage = () => {
  const screens = useBreakpoint();
  const [showCreateListingModal, setShowCreateListingModal] = useState(false);
  const isMobile = !screens.sm; // < md = mobile
  return (
    <div className="requests-wrapper">
      {!isMobile ? <ImageBackground /> : <></>}

      {!isMobile ? (
        <Row
          style={{ alignItems: "end", marginBottom: "38px", marginTop: "20px" }}
        >
          <Col span={12} xl={12} xxl={12} md={24} sm={24} xs={24}>
            <div className="requests-title">Requests</div>
            <div className="requests-heading">
              Apply to get in contact with application posters or add your own
            </div>
          </Col>
          <Col span={12} xl={12} xxl={12} md={24} sm={24} xs={24}>
            <div className="requests-flex-container">
              <Row align="middle">
                <span style={{ marginRight: "12px" }}>
                  <div className="requests-text">
                    Can't find what you're looking for in the marketplace?
                  </div>
                </span>
                {!isMobile ? (
                  <span>
                    <Button
                      className="add-listing-button"
                      type="primary"
                      onClick={() => {
                      if (keycloak.authenticated) {
                        setShowCreateListingModal(true);
                      } else {
                        Modal.confirm({
                          title: "Sign in required",
                          content:
                            "You are not allowed to perform this action. You need to sign in first.",
                          okText: "Sign in",
                          cancelText: "Cancel",
                          onOk: () =>
                            keycloak.login({
                              redirectUri: window.location.href,
                            }),
                        });
                      }
                    }}
                    >
                      Add listing
                    </Button>
                  </span>
                ) : (
                  <></>
                )}
              </Row>
            </div>
            {!isMobile ? (
              <></>
            ) : (
              <Button
                style={{ marginTop: "8px" }}
                className="add-listing-button"
                type="primary"
                onClick={() => {
                      if (keycloak.authenticated) {
                        setShowCreateListingModal(true);
                      } else {
                        Modal.confirm({
                          title: "Sign in required",
                          content:
                            "You are not allowed to perform this action. You need to sign in first.",
                          okText: "Sign in",
                          cancelText: "Cancel",
                          onOk: () =>
                            keycloak.login({
                              redirectUri: window.location.href,
                            }),
                        });
                      }
                    }}
              >
                Add listing
              </Button>
            )}
          </Col>
        </Row>
      ) : (
        <Row
          style={{ alignItems: "end", marginBottom: "38px", marginTop: "20px" }}
        >
          <Col span={12} xl={12} xxl={12} md={24} sm={24} xs={24}>
            <div className="requests-title">Requests</div>
            <div className="requests-heading" style={{ marginTop: "20px" }}>
              Apply to get in contact with application posters or add your own
            </div>

            <div
              className="requests-text"
              style={{ marginTop: "20px", marginBottom: "-8px" }}
            >
              Can't find what you're looking for in the marketplace?
            </div>
            {!isMobile ? (
              <Button
                className="add-listing-button"
                type="primary"
                onClick={() => {
                      if (keycloak.authenticated) {
                        setShowCreateListingModal(true);
                      } else {
                        Modal.confirm({
                          title: "Sign in required",
                          content:
                            "You are not allowed to perform this action. You need to sign in first.",
                          okText: "Sign in",
                          cancelText: "Cancel",
                          onOk: () =>
                            keycloak.login({
                              redirectUri: window.location.href,
                            }),
                        });
                      }
                    }}
              >
                Add listing
              </Button>
            ) : (
              <></>
            )}
          </Col>
          <Col span={12} xl={12} xxl={12} md={24} sm={24} xs={24}>
            {!isMobile ? (
              <></>
            ) : (
              <div style={{ display: "flex", justifyContent: "end" }}>
                {" "}
                <Button
                  style={{ marginTop: "16px" }}
                  className="add-listing-button"
                  type="primary"
                  onClick={() => {
                      if (keycloak.authenticated) {
                        setShowCreateListingModal(true);
                      } else {
                        Modal.confirm({
                          title: "Sign in required",
                          content:
                            "You are not allowed to perform this action. You need to sign in first.",
                          okText: "Sign in",
                          cancelText: "Cancel",
                          onOk: () =>
                            keycloak.login({
                              redirectUri: window.location.href,
                            }),
                        });
                      }
                    }}
                >
                  Add listing
                </Button>
              </div>
            )}
          </Col>
        </Row>
      )}

      <Outlet />
      <CreateListingModal
        showCreateListingModal={showCreateListingModal}
        setShowCreateListingModal={setShowCreateListingModal}
      />
    </div>
  );
};

export { RequestsPage };
